import { render, staticRenderFns } from "./OrderReportDetail.vue?vue&type=template&id=61fec614"
import script from "./OrderReportDetail.vue?vue&type=script&lang=ts"
export * from "./OrderReportDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports